import React from 'react';
import classNames from 'classnames';
import { Languages as Lang } from '@app/i18n';
import styles from './styles.module.scss';
import { Languages } from '@/shared/types';

type LanguageButtonProps = {
    language: Languages;
    current: string;
    change: (lang: string) => void;
};

export const LanguageButton: React.FC<LanguageButtonProps> = ({ language, current, change }) => (
    <a
        data-testid={'select-language-' + language}
        className={classNames(styles['dropdown-item'], { [styles['is-active']]: current === language })}
        onClick={() => change(language)}
    >
        {Lang[language]}
    </a>
);
